var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _g, _g2, _g3, _g4, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginInternet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_42731",
    "data-name": "Grupo 42731",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105.895,
    height: 105.894,
    viewBox: "0 0 105.895 105.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32272",
    "data-name": "Rect\\xE1ngulo 32272",
    width: 3.942,
    height: 3.941,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32274",
    "data-name": "Rect\\xE1ngulo 32274",
    width: 3.943,
    height: 3.944,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32273",
    "data-name": "Rect\\xE1ngulo 32273",
    width: 3.942,
    height: 3.942,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32278",
    "data-name": "Rect\\xE1ngulo 32278",
    width: 3.943,
    height: 3.943,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20913",
    "data-name": "Trazado 20913",
    d: "M303.41,878.517a52.947,52.947,0,1,1-52.947-52.947,52.947,52.947,0,0,1,52.947,52.947",
    transform: "translate(-197.515 -825.57)",
    fill: "#ed92c8",
    opacity: 0.52
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20952",
    "data-name": "Trazado 20952",
    d: "M302.276,903.569h-60.7a2.01,2.01,0,0,1-2.009-2.008V859.477a2.009,2.009,0,0,1,2.009-2.008h60.7a2.01,2.01,0,0,1,2.009,2.008v42.084a2.01,2.01,0,0,1-2.009,2.009",
    transform: "translate(-220.258 -840.029)",
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20953",
    "data-name": "Trazado 20953",
    d: "M300.106,903.569H239.563a2.085,2.085,0,0,1-2.086-2.084h0v-41.93a2.085,2.085,0,0,1,2.085-2.085h60.544a2.088,2.088,0,0,1,2.087,2.086v41.929a2.088,2.088,0,0,1-2.087,2.086",
    transform: "translate(-220.096 -840.029)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20954",
    "data-name": "Trazado 20954",
    d: "M300.382,936.03H243.668a4,4,0,0,1-4-4h0V913.937a4,4,0,0,1,4-4h56.715a4,4,0,0,1,4,4v18.089a4,4,0,0,1-4,4h0",
    transform: "translate(-220.266 -844.112)",
    fill: "#333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20955",
    "data-name": "Trazado 20955",
    d: "M296.849,901.195h-53.79a2.939,2.939,0,0,1-2.94-2.94V863.428a2.94,2.94,0,0,1,2.938-2.942h53.792a2.943,2.943,0,0,1,2.941,2.942v34.826a2.941,2.941,0,0,1-2.94,2.942h0",
    transform: "translate(-220.302 -840.263)",
    fill: "#7ac5ba"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20956",
    "data-name": "Trazado 20956",
    d: "M299.94,936.03h-59.9a2.408,2.408,0,0,1-2.4-2.406v-21.28a2.409,2.409,0,0,1,2.407-2.407h59.9a2.407,2.407,0,0,1,2.406,2.407v21.28a2.407,2.407,0,0,1-2.406,2.406",
    transform: "translate(-220.108 -844.112)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20957",
    "data-name": "Trazado 20957",
    d: "M243.856,913.659a1.774,1.774,0,0,1-1.856,1.66,1.673,1.673,0,0,1-.368-3.325,1.641,1.641,0,0,1,.368,0,1.774,1.774,0,0,1,1.856,1.66",
    transform: "translate(-220.303 -844.271)",
    fill: "#f0f1f1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20958",
    "data-name": "Trazado 20958",
    d: "M249.369,913.66a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-220.732 -844.272)",
    fill: "#f0f1f1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20959",
    "data-name": "Trazado 20959",
    d: "M254.884,913.66a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-221.161 -844.272)",
    fill: "#f0f1f1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20960",
    "data-name": "Trazado 20960",
    d: "M260.4,913.66a1.867,1.867,0,1,1-2.063-1.648,1.712,1.712,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-221.59 -844.272)",
    fill: "#f0f1f1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20961",
    "data-name": "Trazado 20961",
    d: "M265.912,913.66a1.868,1.868,0,1,1-2.065-1.648,1.727,1.727,0,0,1,.207-.012,1.773,1.773,0,0,1,1.857,1.66",
    transform: "translate(-222.018 -844.272)",
    fill: "#f0f1f1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20962",
    "data-name": "Trazado 20962",
    d: "M271.426,913.66a1.868,1.868,0,1,1-2.065-1.648,1.743,1.743,0,0,1,.208-.012,1.774,1.774,0,0,1,1.856,1.66",
    transform: "translate(-222.449 -844.272)",
    fill: "#f0f1f1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20963",
    "data-name": "Trazado 20963",
    d: "M276.938,913.66a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-222.877 -844.272)",
    fill: "#f0f1f1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20964",
    "data-name": "Trazado 20964",
    d: "M282.453,913.66a1.867,1.867,0,1,1-2.063-1.648A1.713,1.713,0,0,1,280.6,912a1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-223.306 -844.272)",
    fill: "#f0f1f1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20965",
    "data-name": "Trazado 20965",
    d: "M287.968,913.66a1.867,1.867,0,1,1-2.063-1.648,1.712,1.712,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-223.735 -844.272)",
    fill: "#f0f1f1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20966",
    "data-name": "Trazado 20966",
    d: "M293.482,913.66a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-224.164 -844.272)",
    fill: "#f0f1f1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20967",
    "data-name": "Trazado 20967",
    d: "M299,913.66a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012A1.772,1.772,0,0,1,299,913.66",
    transform: "translate(-224.594 -844.272)",
    fill: "#f0f1f1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20968",
    "data-name": "Trazado 20968",
    d: "M304.51,913.66a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-225.023 -844.272)",
    fill: "#f0f1f1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20969",
    "data-name": "Trazado 20969",
    d: "M243.855,918.569a1.772,1.772,0,0,1-1.856,1.66,1.673,1.673,0,0,1-.376-3.324,1.716,1.716,0,0,1,.376,0,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-220.302 -844.653)",
    fill: "#f0f1f1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20970",
    "data-name": "Trazado 20970",
    d: "M249.369,918.57a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-220.732 -844.654)",
    fill: "#f0f1f1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20971",
    "data-name": "Trazado 20971",
    d: "M254.884,918.57a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-221.161 -844.654)",
    fill: "#f0f1f1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20972",
    "data-name": "Trazado 20972",
    d: "M260.4,918.57a1.867,1.867,0,1,1-2.063-1.648,1.712,1.712,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-221.59 -844.654)",
    fill: "#cccacb"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20973",
    "data-name": "Trazado 20973",
    d: "M265.912,918.57a1.868,1.868,0,1,1-2.065-1.648,1.727,1.727,0,0,1,.207-.012,1.773,1.773,0,0,1,1.857,1.66",
    transform: "translate(-222.018 -844.654)",
    fill: "#f0f1f1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20974",
    "data-name": "Trazado 20974",
    d: "M271.426,918.57a1.868,1.868,0,1,1-2.065-1.648,1.743,1.743,0,0,1,.208-.012,1.774,1.774,0,0,1,1.856,1.66",
    transform: "translate(-222.449 -844.654)",
    fill: "#f0f1f1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20975",
    "data-name": "Trazado 20975",
    d: "M276.938,918.57a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-222.877 -844.654)",
    fill: "#f0f1f1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20976",
    "data-name": "Trazado 20976",
    d: "M282.453,918.57a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-223.306 -844.654)",
    fill: "#f0f1f1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20977",
    "data-name": "Trazado 20977",
    d: "M287.968,918.57a1.867,1.867,0,1,1-2.063-1.648,1.712,1.712,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-223.735 -844.654)",
    fill: "#f0f1f1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20978",
    "data-name": "Trazado 20978",
    d: "M293.482,918.57a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-224.164 -844.654)",
    fill: "#f0f1f1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20979",
    "data-name": "Trazado 20979",
    d: "M299,918.57a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012A1.772,1.772,0,0,1,299,918.57",
    transform: "translate(-224.594 -844.654)",
    fill: "#f0f1f1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20980",
    "data-name": "Trazado 20980",
    d: "M304.51,918.57a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-225.023 -844.654)",
    fill: "#f0f1f1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20981",
    "data-name": "Trazado 20981",
    d: "M243.856,923.477a1.774,1.774,0,0,1-1.856,1.66,1.673,1.673,0,1,1-.368-3.325,1.634,1.634,0,0,1,.368,0,1.774,1.774,0,0,1,1.856,1.66",
    transform: "translate(-220.303 -845.035)",
    fill: "#f0f1f1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20982",
    "data-name": "Trazado 20982",
    d: "M249.369,923.479a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-220.732 -845.036)",
    fill: "#f0f1f1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20983",
    "data-name": "Trazado 20983",
    d: "M254.884,923.479a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-221.161 -845.036)",
    fill: "#cccacb"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20984",
    "data-name": "Trazado 20984",
    d: "M260.4,923.479a1.867,1.867,0,1,1-2.063-1.648,1.712,1.712,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-221.59 -845.036)",
    fill: "#f0f1f1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20985",
    "data-name": "Trazado 20985",
    d: "M265.912,923.479a1.868,1.868,0,1,1-2.065-1.648,1.727,1.727,0,0,1,.207-.012,1.773,1.773,0,0,1,1.857,1.66",
    transform: "translate(-222.018 -845.036)",
    fill: "#f0f1f1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20986",
    "data-name": "Trazado 20986",
    d: "M271.426,923.479a1.868,1.868,0,1,1-2.065-1.648,1.865,1.865,0,0,1,2.065,1.648",
    transform: "translate(-222.449 -845.036)",
    fill: "#f0f1f1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20987",
    "data-name": "Trazado 20987",
    d: "M276.938,923.479a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-222.877 -845.036)",
    fill: "#cccacb"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20988",
    "data-name": "Trazado 20988",
    d: "M282.453,923.479a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-223.306 -845.036)",
    fill: "#cccacb"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20989",
    "data-name": "Trazado 20989",
    d: "M287.968,923.479a1.867,1.867,0,1,1-2.063-1.648,1.712,1.712,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-223.735 -845.036)",
    fill: "#f0f1f1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20990",
    "data-name": "Trazado 20990",
    d: "M293.482,923.479a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-224.164 -845.036)",
    fill: "#f0f1f1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20991",
    "data-name": "Trazado 20991",
    d: "M304.082,923.479c0,.914-1.98,1.66-4.4,1.66s-4.4-.748-4.4-1.66,1.979-1.66,4.4-1.66,4.4.748,4.4,1.66",
    transform: "translate(-224.594 -845.036)",
    fill: "#f0f1f1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20992",
    "data-name": "Trazado 20992",
    d: "M243.856,928.387a1.774,1.774,0,0,1-1.856,1.66,1.673,1.673,0,1,1-.368-3.325,1.641,1.641,0,0,1,.368,0,1.774,1.774,0,0,1,1.856,1.66",
    transform: "translate(-220.303 -845.417)",
    fill: "#f0f1f1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20993",
    "data-name": "Trazado 20993",
    d: "M249.369,928.388a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-220.732 -845.418)",
    fill: "#cccacb"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20994",
    "data-name": "Trazado 20994",
    d: "M254.884,928.388a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-221.161 -845.418)",
    fill: "#f0f1f1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20995",
    "data-name": "Trazado 20995",
    d: "M260.4,928.388a1.867,1.867,0,1,1-2.063-1.648,1.712,1.712,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-221.59 -845.418)",
    fill: "#f0f1f1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20996",
    "data-name": "Trazado 20996",
    d: "M265.912,928.388a1.868,1.868,0,1,1-2.065-1.648,1.727,1.727,0,0,1,.207-.012,1.773,1.773,0,0,1,1.857,1.66",
    transform: "translate(-222.018 -845.418)",
    fill: "#f0f1f1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20997",
    "data-name": "Trazado 20997",
    d: "M271.426,928.388a1.868,1.868,0,1,1-2.065-1.648,1.731,1.731,0,0,1,.208-.012,1.774,1.774,0,0,1,1.856,1.66",
    transform: "translate(-222.449 -845.418)",
    fill: "#f0f1f1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20998",
    "data-name": "Trazado 20998",
    d: "M276.938,928.388a1.867,1.867,0,1,1-2.063-1.648,1.712,1.712,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-222.877 -845.418)",
    fill: "#f0f1f1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20999",
    "data-name": "Trazado 20999",
    d: "M282.453,928.388a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-223.306 -845.418)",
    fill: "#f0f1f1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21000",
    "data-name": "Trazado 21000",
    d: "M287.968,928.388a1.867,1.867,0,1,1-2.063-1.648,1.712,1.712,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-223.735 -845.418)",
    fill: "#f0f1f1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21001",
    "data-name": "Trazado 21001",
    d: "M293.482,928.388a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-224.164 -845.418)",
    fill: "#f0f1f1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21002",
    "data-name": "Trazado 21002",
    d: "M299,928.388a1.867,1.867,0,1,1-2.063-1.648,1.713,1.713,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-224.594 -845.418)",
    fill: "#f0f1f1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21003",
    "data-name": "Trazado 21003",
    d: "M304.519,925.908c0,2.081-.835,3.781-1.856,3.781s-1.855-1.7-1.855-3.781.835-3.781,1.855-3.781,1.856,1.7,1.856,3.781",
    transform: "translate(-225.025 -845.06)",
    fill: "#f0f1f1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21004",
    "data-name": "Trazado 21004",
    d: "M243.855,933.3a1.772,1.772,0,0,1-1.856,1.66,1.673,1.673,0,0,1-.376-3.324,1.708,1.708,0,0,1,.376,0,1.774,1.774,0,0,1,1.856,1.66",
    transform: "translate(-220.302 -845.799)",
    fill: "#f0f1f1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21005",
    "data-name": "Trazado 21005",
    d: "M249.369,933.3a1.867,1.867,0,1,1-2.063-1.648,1.725,1.725,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-220.732 -845.8)",
    fill: "#f0f1f1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21006",
    "data-name": "Trazado 21006",
    d: "M254.884,933.3a1.867,1.867,0,1,1-2.063-1.648,1.725,1.725,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-221.161 -845.8)",
    fill: "#f0f1f1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21007",
    "data-name": "Trazado 21007",
    d: "M280.737,933.3c0,.914-2.992,1.66-6.649,1.66H263.335c-3.657,0-6.649-.748-6.649-1.66s2.992-1.66,6.649-1.66h10.754c3.657,0,6.649.748,6.649,1.66",
    transform: "translate(-221.591 -845.8)",
    fill: "#f0f1f1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21008",
    "data-name": "Trazado 21008",
    d: "M287.968,933.3a1.867,1.867,0,1,1-2.063-1.648,1.724,1.724,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-223.735 -845.8)",
    fill: "#f0f1f1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21009",
    "data-name": "Trazado 21009",
    d: "M293.482,933.3a1.867,1.867,0,1,1-2.063-1.648,1.725,1.725,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-224.164 -845.8)",
    fill: "#f0f1f1"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21010",
    "data-name": "Trazado 21010",
    d: "M299,933.3a1.867,1.867,0,1,1-2.063-1.648,1.726,1.726,0,0,1,.207-.012A1.772,1.772,0,0,1,299,933.3",
    transform: "translate(-224.594 -845.8)",
    fill: "#f0f1f1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21011",
    "data-name": "Trazado 21011",
    d: "M304.51,933.3a1.867,1.867,0,1,1-2.063-1.648,1.725,1.725,0,0,1,.207-.012,1.772,1.772,0,0,1,1.856,1.66",
    transform: "translate(-225.023 -845.8)",
    fill: "#f0f1f1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21012",
    "data-name": "Trazado 21012",
    d: "M331.534,930.315a5.66,5.66,0,0,1-5.658,5.659h-3.4a5.66,5.66,0,0,1-5.659-5.659v-14.68a5.658,5.658,0,0,1,5.659-5.658h3.4a5.659,5.659,0,0,1,5.658,5.658Z",
    transform: "translate(-226.271 -844.115)",
    fill: "#333"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21013",
    "data-name": "Trazado 21013",
    d: "M329.892,930.315a5.658,5.658,0,0,1-5.656,5.659h-3.4a5.66,5.66,0,0,1-5.658-5.659v-14.68a5.659,5.659,0,0,1,5.658-5.658h3.4a5.658,5.658,0,0,1,5.658,5.658h0Z",
    transform: "translate(-226.143 -844.115)",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21014",
    "data-name": "Trazado 21014",
    d: "M322.6,909.976v10.179h-7.429v-4.5a5.735,5.735,0,0,1,5.723-5.683Z",
    transform: "translate(-226.143 -844.115)",
    fill: "#f0f1f1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21015",
    "data-name": "Trazado 21015",
    d: "M293.294,898.377H247.377a2.366,2.366,0,0,1-2.365-2.364V866.187a2.366,2.366,0,0,1,2.365-2.365h45.917a2.366,2.366,0,0,1,2.365,2.365v29.825a2.366,2.366,0,0,1-2.365,2.364",
    transform: "translate(-220.683 -840.523)",
    fill: "#fff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21016",
    "data-name": "Trazado 21016",
    d: "M247.374,865.385a.566.566,0,1,1-.567-.565h0a.565.565,0,0,1,.566.564Z",
    transform: "translate(-220.777 -840.6)",
    fill: "#d00c7f"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21017",
    "data-name": "Trazado 21017",
    d: "M249.554,865.385a.566.566,0,1,1-.567-.565h0a.566.566,0,0,1,.566.565",
    transform: "translate(-220.948 -840.6)",
    fill: "#cccacb"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21018",
    "data-name": "Trazado 21018",
    d: "M251.736,865.385a.566.566,0,1,1-.567-.565h0a.566.566,0,0,1,.566.565",
    transform: "translate(-221.118 -840.6)",
    fill: "#10ae97"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32261",
    "data-name": "Rect\\xE1ngulo 32261",
    width: 50.62,
    height: 3.301,
    transform: "translate(24.382 26.372)",
    fill: "#cccacb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32262",
    "data-name": "Rect\\xE1ngulo 32262",
    width: 50.62,
    height: 3.989,
    transform: "translate(24.382 29.673)",
    fill: "#f0f1f1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32263",
    "data-name": "Rect\\xE1ngulo 32263",
    width: 7.429,
    height: 2.752,
    transform: "translate(64.273 30.235)",
    fill: "#d00c7f"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32264",
    "data-name": "Rect\\xE1ngulo 32264",
    width: 23.522,
    height: 0.963,
    transform: "translate(27.959 35.737)",
    fill: "#cccacb"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32265",
    "data-name": "Rect\\xE1ngulo 32265",
    width: 23.522,
    height: 0.963,
    transform: "translate(27.959 38.625)",
    fill: "#cccacb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32266",
    "data-name": "Rect\\xE1ngulo 32266",
    width: 11.829,
    height: 1.101,
    transform: "translate(27.959 41.377)",
    fill: "#cccacb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32267",
    "data-name": "Rect\\xE1ngulo 32267",
    width: 23.522,
    height: 0.963,
    transform: "translate(27.959 47.842)",
    fill: "#cccacb"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32268",
    "data-name": "Rect\\xE1ngulo 32268",
    width: 23.522,
    height: 0.963,
    transform: "translate(27.959 50.593)",
    fill: "#cccacb"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32269",
    "data-name": "Rect\\xE1ngulo 32269",
    width: 12.654,
    height: 0.963,
    transform: "translate(27.959 53.481)",
    fill: "#cccacb"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32270",
    "data-name": "Rect\\xE1ngulo 32270",
    width: 17.471,
    height: 19.534,
    transform: "translate(54.231 35.737)",
    fill: "#f0f1f1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42713",
    "data-name": "Grupo 42713",
    transform: "translate(66.017 31.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42712",
    "data-name": "Grupo 42712",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42711",
    "data-name": "Grupo 42711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42710",
    "data-name": "Grupo 42710",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21019",
    "data-name": "Trazado 21019",
    d: "M294.159,874.895a1.971,1.971,0,1,1-1.973-1.972,1.971,1.971,0,0,1,1.973,1.972Z",
    transform: "translate(-290.217 -872.923)",
    fill: "#333"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42718",
    "data-name": "Grupo 42718",
    transform: "translate(66.702 37.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42717",
    "data-name": "Grupo 42717",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42716",
    "data-name": "Grupo 42716",
    transform: "translate(0.001 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42715",
    "data-name": "Grupo 42715",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21020",
    "data-name": "Trazado 21020",
    d: "M294.9,881.306a1.972,1.972,0,1,1-1.972-1.972h0a1.969,1.969,0,0,1,1.97,1.97Z",
    transform: "translate(-290.961 -879.336)",
    fill: "#333"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42723",
    "data-name": "Grupo 42723",
    transform: "translate(67.943 44.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42722",
    "data-name": "Grupo 42722",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42721",
    "data-name": "Grupo 42721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42720",
    "data-name": "Grupo 42720",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21021",
    "data-name": "Trazado 21021",
    d: "M296.247,888.916a1.971,1.971,0,1,1-1.972-1.971,1.971,1.971,0,0,1,1.972,1.971",
    transform: "translate(-292.305 -886.944)",
    fill: "#333"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42728",
    "data-name": "Grupo 42728",
    transform: "translate(69.868 52.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42727",
    "data-name": "Grupo 42727",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42726",
    "data-name": "Grupo 42726",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42725",
    "data-name": "Grupo 42725",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21022",
    "data-name": "Trazado 21022",
    d: "M298.335,897.417a1.972,1.972,0,1,1-1.973-1.971,1.971,1.971,0,0,1,1.973,1.971",
    transform: "translate(-294.393 -895.446)",
    fill: "#10ae97"
  })))))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32279",
    "data-name": "Rect\\xE1ngulo 32279",
    width: 87.884,
    height: 74.479,
    transform: "translate(17.383 17.44)",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginInternet);
export default __webpack_public_path__ + "static/media/Login_Internet.3e47e758b7d83032e9cda30cd256937b.svg";
export { ForwardRef as ReactComponent };